
export class CustomFvValidators {
  public static PasswordStrength = () : any => {
    return {
      validate: function (input: HTMLInputElement) {
        const value = input.value;
        if (value === '') {
          return {
            valid: true,
          };
        }

        // Check the password strength
        if (value.length < 8) {
          return {
            valid: false,
            message: "Password requirement not met: min of 1 Capital, 1 number and 8 characters"
          };
        }

        // The password doesn't contain any uppercase character
        if (value === value.toLowerCase()) {
          return {
            valid: false,
            message: "Password requirement not met: min of 1 Capital, 1 number and 8 characters"
          };
        }

        // The password doesn't contain any uppercase character
        if (value === value.toUpperCase()) {
          return {
            valid: false,
            message: "Password requirement not met: min of 1 Capital, 1 number and 8 characters"
          };
        }

        // The password doesn't contain any digit
        if (value.search(/[0-9]/) < 0) {
          return {
            valid: false,
            message: "Password requirement not met: min of 1 Capital, 1 number and 8 characters"
          };
        }

        return {
          valid: true
        };
      }
    };
  }

  public static UrlValidator = (): any => {
    return {
      validate: function (input: HTMLInputElement) {
        const value = input.value;
  
        // Allow empty values (valid if the field is not required)
        if (value === '') {
          return {
            valid: true,
          };
        }
  
        // Regular expression for relative URLs
        const relativeUrlPattern = /^\/[a-zA-Z0-9\-\/]*$/;

        // Regular expression for page anchor links such as #section-1
        const anchorUrlPattern = /^#[a-zA-Z][a-zA-Z0-9\-_:.]*$/;
  
        // Regular expression for absolute URLs
        const absoluteUrlPattern = /^https?:\/\/[a-zA-Z0-9\-\.]+(:[0-9]+)?(\/[a-zA-Z0-9\-\/]*)?$/;
  
        // Check if the value matches either pattern
        if (relativeUrlPattern.test(value) || anchorUrlPattern.test(value) || absoluteUrlPattern.test(value)) {
          return {
            valid: true,
          };
        }
  
        // If the value doesn't match any of the patterns, it's invalid
        return {
          valid: false,
          message: "Enter a valid relative URL, absolute URL, page anchor such as '#section', or leave the field blank.",
        };
      },
    };
  };
  
}
